
import { defineComponent } from "vue";
import { useRouter } from "vue-router";
import runEvn from "@/modular/runEvn/RunEvn";

const fileBaseUrl = runEvn().fileBaseUrl;

export default defineComponent({
    setup() {
        const router = useRouter();
        return {
            router, //一定要要放在return里才能在模板上面使用
        };
    },
    name: "ShopCardView",
    props: {
        data: {
            type: Object,
            default: null,
        },
    },
    methods: {
        goGoodsDetails() {
            const id = this.data.id;
            sessionStorage.setItem("type", JSON.stringify(0));
            this.router.push(`/shop/goods/detail/${id}`);
        },
        img(key: string) {
            return fileBaseUrl + key;
        },
        getCoverImg(imgs: any) {
            var coverImg = "";
            try {
                coverImg = imgs.split(",")[0];
            } catch (e) {
                coverImg = "";
            }
            return this.img(coverImg);
        },
        addToShopCart(event) {
            // 通知后台，回调成功后执行下面的函数
            this.$refs.cart.drop(event.target);
        },
        goToCart() {
            this.router.push(`/shop/cart/home`);
        },
    },
    data() {
        return {
            xxx: 45,
        };
    },
});
